module.exports = __webpack_public_path__ + "static/media/u50_premium_contract6.b8745e8f.webp";